import {memo} from 'react';
import {Card, CardBody, Typography} from "@material-tailwind/react";
import {LinearChartProps} from "./LinearChart";
import AreaChart from "./AreaChart";
import TitleWithInfoTooltip from "../TitleWithInfoTooltip";

interface LinearChartsInterface {
    title: string,
    data: LinearChartProps,
    tooltip?: string,
}
interface DashboardLinearChartsProps {
    elements: LinearChartsInterface[],
}

const DashboardAreaCharts = ({elements}: DashboardLinearChartsProps) => {
    return (
        <div className="grid md:grid-cols-2 gap-4 mt-12 mb-4">
            {elements.map((e) => {
                return <Card key={e.title} className="bg-white dark:bg-blue-gray-900 dark:text-gray-500">
                    <CardBody className="w-full px-2 block h-96" id='successful_deposits_linear'>
                        <Typography variant="h6" className="mb-6 text-center">
                            <TitleWithInfoTooltip title={e.title} tooltip={e.tooltip} className="justify-center"/>
                        </Typography>
                        <AreaChart series={e.data.series} labels={e.data.labels} isLoading={e.data.isLoading} />
                    </CardBody>
                </Card>
            })}
        </div>
    );
}

export default memo(DashboardAreaCharts);
